// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"365":"c4d32847","811":"7510e427"}[chunkId] + ".chunk.js");